module.exports = __webpack_public_path__ + "img/location.15ced32a.svg";